<template>
  <div class="dynamic-field-container">
    <label>{{ field.label }}</label>
    <el-select
      data-vv-validate-on="change"
      :name="fieldName"
      :data-vv-as="fieldName"
      class="thirty-percent"
      v-model="proxyValueHours"
      v-validate="fieldValidationRules"
      placeholder="hours"
      :disabled="isTaskFieldDisabled"
      :value="field.value">
      <el-option v-for="option in hourIncrements"
                 class="select"
                 :value="option.value"
                 :label="option.label"
                 :key="option.label" />
    </el-select>
    :
    <el-select
        data-vv-validate-on="change"
        :name="fieldName"
        :data-vv-as="fieldName"
        class="thirty-percent"
        v-model="proxyValueMinutes"
        v-validate="fieldValidationRules"
        placeholder="minutes"
        :disabled="isTaskFieldDisabled"
        :value="field.value">
      <el-option v-for="option in minuteIncrements"
                 class="select"
                 :value="option.value"
                 :label="option.label"
                 :key="option.label" />
    </el-select>
    <small class="text-danger" v-show="errors.has(fieldName)" style="display: block; margin-top: 7px;">
      {{ getError(fieldName) }}
    </small>
  </div>
</template>

<script>
  import {generateDynamicFieldValidation, canEditTaskField} from 'src/utilities/utils'

  export default {
    inject: ['$validator'],
    props: ['field', 'value', 'commit', 'task'],
    fieldName: 'temp',
    computed: {
      hourIncrements() {
        const hours = []
        for (let i = 0; i <= 250; i++) {
          hours.push( {label: `${i.toString()}`, value: i})
        }
        return hours
      },
      fieldValidationRules() {
        // expressions override other validation logic
        if (this.field.expression) {
          this.fieldValidation = function(str) {
            return eval(str).apply(this)
          }.call(this, this.field.expression)
        }
        return this.fieldValidation
      },
      proxyValueHours: {
        get() {
          if (Math.trunc(this.value) || this.proxyValueMinutes) {
            return Math.trunc(this.value)
          }
        },
        set(newHourValue) {
          const newValue = (Number((this.value - Math.trunc(this.value)).toFixed(2)) + newHourValue)
          this.$store.commit(this.commit, { key: this.field.key, value: newValue})
          this.$eventHub.$emit('timeTrackingChanged', newValue)
        }
      },
      proxyValueMinutes: {
        get() {
          if (this.value ==  null) {
            return
          }
          for (const increment of this.minuteIncrements) {
            if ((this.value - Math.trunc(this.value)).toFixed(2).toString().includes(increment.value.toFixed(2).toString())) {
              return (increment.label)
            }
          }
        },
        set(newMinuteValue) {
          const newValue = Math.trunc(this.value) + newMinuteValue
          this.$store.commit(this.commit,{ key: this.field.key, value: newValue })
          this.$eventHub.$emit('timeTrackingChanged', newValue)
        }
      },
      isTaskFieldDisabled() {
        if (this.disabled) {
          return true
        }
        return !canEditTaskField(this)
      }
    },
    data () {
      return {
        fieldValidation: {},
        minuteIncrements: [
          {label: '00', value: 0.00},
          {label: '05', value: 0.08},
          {label: '10', value: 0.17},
          {label: '15', value: 0.25},
          {label: '20', value: 0.33},
          {label: '25', value: 0.42},
          {label: '30', value: 0.5},
          {label: '35', value: 0.58},
          {label: '40', value: 0.67},
          {label: '45', value: 0.75},
          {label: '50', value: 0.83},
          {label: '55', value: 0.92}
        ],
        statusOnLoad: null
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      }
    },
    beforeMount() {
      generateDynamicFieldValidation(this)
      this.statusOnLoad = JSON.parse(JSON.stringify(this.task.status))
    }
  }
</script>

<style scoped>
  label {
    display: block;
  }
  .dynamic-field-container {
    margin-bottom: 10px;
  }
  .thirty-percent {
    width: 30%;
  }
</style>
